import R from 'ramda';
import * as introductionActions from './introductionActions';
import * as submissionActions from 'submission/submissionActions';

import {
  initialStepState,
  setCompleted,
  setLoadingLocalStorage,
} from 'common/stepReducerUtil';

const initialIntroductionStepState = {
  loadingInitData: false,
  loadingLocalStorage: true,
  fields: {
    copyrightFileName: '',
    dissertationFileName: '',
  },
};

const initialState = R.merge(initialStepState, initialIntroductionStepState);

const localStorageLoaded = (data, state) =>
  R.pipe(
    setLoadingLocalStorage(false),
    setCompleted(R.isEmpty(data) ? initialState.completed : data.completed),
  )(state);

const cancelSubmission = R.pipe(setCompleted(initialState.completed));

const introductionReducer = (state = initialState, action) => {
  switch (action.type) {
    case introductionActions.COMPLETE_STEP:
    case submissionActions.SUBMIT:
      return setCompleted(true, state);

    case introductionActions.LOCAL_STORAGE_LOADED:
      return localStorageLoaded(action.data, state);

    case submissionActions.CANCEL_SUBMISSION:
      return cancelSubmission(state);

    default:
      return state;
  }
};

export default introductionReducer;



// WEBPACK FOOTER //
// ./src/introduction/introductionReducer.js